// /join/<CODE>/anything: extra segments make the link invalid (003 edge case).
import { JoinLandingScreen } from "@/join/JoinLandingScreen";

export default function JoinWithExtraSegments() {
  return <JoinLandingScreen rawCode="" />;
}
